import { render, staticRenderFns } from "./GroupAppSettingTable.vue?vue&type=template&id=5db2644f&"
import script from "./GroupAppSettingTable.vue?vue&type=script&lang=js&"
export * from "./GroupAppSettingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports